import { render, staticRenderFns } from "./mergedExport.vue?vue&type=template&id=5522091c&scoped=true&"
import script from "./mergedExport.vue?vue&type=script&lang=js&"
export * from "./mergedExport.vue?vue&type=script&lang=js&"
import style0 from "./mergedExport.vue?vue&type=style&index=0&id=5522091c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5522091c",
  null
  
)

export default component.exports